import EvaluatorPaymentsBaseTab from "./EvaluatorPaymentsBaseTab";

export default class PendingApprovalVatTab extends EvaluatorPaymentsBaseTab {
    getType() {
        return "pending_approval_vat";
    }
}